// THIS FILE IS GENERATED, DO NOT MODIFY MANUALLY. ##checksum##: 730221637
import { createAction } from 'typesafe-actions';

export const setHasAccounts = createAction('EMPTY_STATE/SET_HAS_ACCOUNTS')<boolean | undefined>();
